export const dynamicFormScroll = () => {
  let element = document.getElementById("dynamic_form_container");
  element?.scrollTo({ top: 0, behavior: "smooth" });
};

export const dynamicFormScrollBottom = () => {
  let element = document.getElementById("dynamic_form_container");
  element?.scrollTo({ top: element.scrollHeight, behavior: "smooth" });
};

export const requestedDocuments = {
  id: '("5f9e1b1b8b2b8c0001a1b1b1")',
  RMId: '("5f9e1b545pu78054544484b1")',
  section: 1,
  group: "account_information",
  fields: {
    account_type: "account_type",
    citizenship: "citizenship",
    // i.e name:id
    // "mode_of_operation":"mode_of_operation",
    // "service_type":"service_type",
  },
};

export const isItRMRequestedFlow = () => {
  const dummyURL =
    "signdesk.com/28639216934218032/5f9e1b1b8b2b8c0001a1b1b1/update/5f9e1b545pu78054544484b1";
  // if this URL contains update or view then return true
  return dummyURL.includes("update") || dummyURL.includes("view")
    ? true
    : false;
};

export const handleIsThisTheRequestedDocument = (field, requestedDocuments) => {
  if (isItRMRequestedFlow()) {
    const fieldsRequired = requestedDocuments.fields;
    const currentFieldId = field.name ? field.name : field.id;

    return fieldsRequired[currentFieldId] ? true : false;
  } else {
    return false; // if the URL is not for update by RM then return false
  }
};
